import React from 'react'
import './index.css'
import Flex from 'components/Flex'
import Tooltip from 'components/Tooltip'
import useSelector from 'hooks/use-selector'
import getCurrentMemberFirstName from 'modules/squad/redux/selectors/get-current-member-first-name'
import getLikedTooltipLabelUtil from 'pages/Squad/containers/Friends/CurrentFriendSampleSummary/Content/ItemsYouBothLoved/Content/LikedSuperLiked/utils/get-liked-tooltip-label'
import getSuperLikedTooltipLabelUtil from 'pages/Squad/containers/Friends/CurrentFriendSampleSummary/Content/ItemsYouBothLoved/Content/LikedSuperLiked/utils/get-super-liked-tooltip-label'

export default function ItemsYouBothLovedContentLikedSuperLiked (props) {
  /**
   * @type import('modules/squad/types').ItemsYouBothLovedInfo
   */
  const activeItem = props.activeItem
  const currentMemberFirstName = useSelector(getCurrentMemberFirstName)

  const ownerHasLiked = activeItem?.squad_owner_rating === 'like'
  const memberHasLiked = activeItem?.squad_member_rating === 'like'
  const hasLiked = ownerHasLiked || memberHasLiked
  const hasBothLiked = ownerHasLiked && memberHasLiked
  const likedTooltipLabel = getLikedTooltipLabelUtil({
    memberHasLiked, hasBothLiked, ownerHasLiked, currentMemberFirstName
  })

  const ownerHasSuperLiked = activeItem?.squad_owner_rating === 'super_like'
  const memberHasSuperLiked = activeItem?.squad_member_rating === 'super_like'
  const hasSuperLiked = ownerHasSuperLiked || memberHasSuperLiked
  const hasBothSuperLiked = ownerHasSuperLiked && memberHasSuperLiked
  const superLikedTooltipLabel = getSuperLikedTooltipLabelUtil({
    memberHasSuperLiked, hasBothSuperLiked, ownerHasSuperLiked, currentMemberFirstName
  })

  return (
    <Flex
      className='squad-items-you-both-loved-content-liked-super-liked'
    >
      {!!hasLiked && (
        <Tooltip
          arrow
          placement='top'
          title={likedTooltipLabel}
        >
          <svg width='44' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_878_22964)'>
              <circle cx='21.9783' cy='21.6398' r='20' transform='rotate(-5 21.9783 21.6398)' fill='#E15EC4' />
              <path d='M17.3748 15.6937C16.9155 15.7339 16.4357 15.8703 15.9441 16.1299C13.7965 17.2636 13.4385 19.6761 14.0148 21.438C15.4282 25.7608 21.2585 27.7899 21.9914 28.0292C22.6715 27.6659 28.0608 24.6524 28.702 20.153C28.9636 18.3178 28.1921 16.004 25.88 15.2604C23.6267 14.5355 21.9672 15.9708 21.2311 17.4198C21.1695 17.5418 20.98 17.5584 20.8976 17.449C20.1501 16.455 18.8717 15.5627 17.3748 15.6937Z' fill='white' />
            </g>
            <defs>
              <clipPath id='clip0_878_22964'>
                <rect width='40' height='40' fill='white' transform='translate(0 3.48633) rotate(-5)' />
              </clipPath>
            </defs>
          </svg>
        </Tooltip>
      )}

      {!!hasSuperLiked && (
        <Tooltip
          arrow
          placement='top'
          title={superLikedTooltipLabel}
        >
          <svg className='super-like-icon' width='44' height='45' viewBox='0 0 44 45' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_357_55621)'>
              <circle cx='22.3124' cy='22.3916' r='20' transform='rotate(5 22.3124 22.3916)' fill='#4439DF' />
              <path d='M15.599 17.8312C15.1383 17.7909 14.6407 17.842 14.11 18.0128C11.7914 18.7586 11.0178 21.079 11.2801 22.9195C11.9232 27.4352 17.3281 30.4546 18.0102 30.8186C18.7452 30.5782 24.5928 28.5404 26.0096 24.2082C26.5875 22.4411 26.2286 20.0215 24.0745 18.8844C21.9753 17.776 20.0864 18.9046 19.107 20.2076C19.0249 20.3174 18.8349 20.3007 18.7725 20.1783C18.2074 19.0664 17.1002 17.9625 15.599 17.8312Z' fill='white' />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21.6051 13.839C22.1358 13.6682 22.6335 13.617 23.0941 13.6573C24.5953 13.7887 25.7025 14.8925 26.2677 16.0045C26.33 16.1269 26.52 16.1435 26.6021 16.0338C27.5815 14.7308 29.4704 13.6022 31.5696 14.7106C33.7237 15.8476 34.0826 18.2673 33.5047 20.0343C32.493 23.1277 29.2225 25.0512 27.167 25.9859C27.3764 25.6028 27.555 25.2045 27.696 24.7911C28.3899 22.7577 27.8957 19.1489 25.2651 17.8258C22.7885 16.5799 19.9993 17.0831 18.7438 18.4675C18.5937 16.6781 19.4019 14.5476 21.6051 13.839Z'
                fill='#9C99EE'
              />
            </g>
            <defs>
              <clipPath id='clip0_357_55621'>
                <rect width='40' height='40' fill='white' transform='translate(3.82031 0.697266) rotate(5)' />
              </clipPath>
            </defs>
          </svg>
        </Tooltip>
      )}

    </Flex>
  )
}
